module.exports = __webpack_public_path__ + "static/media/supplemental-sources.c68bdec7.md";